// Login
export const storeLoginToken = "storeLoginTokenSalesPerson";
export const removeLoginToken = "removeLoginTokenSalesPerson";
export const sessionExpired = "sessionExpiredSalesPerson";
export const userSession = "userSessionSalesPerson";
export const userSessionAuthenticate = "userSessionAuthenticateSalesPerson";
export const isLoadingAction = "isLoadingSalesPerson";